module.exports = __webpack_public_path__ + "static/media/intro.4c10baf2.mp3";